<template>
  <div>
    <div class="login-outer-wrap">
      <div class="page-header">
        <span v-if="activeTab === 'signIn'">SIGN IN</span>
        <span v-if="activeTab === 'signUp'">SIGN UP</span>
        <span v-if="activeTab === 'forgotPassword'">FORGOT PASSWORD</span>
      </div>
      <div class="login-wrap">
        <v-tabs :active-tab-key="activeTab" @tab-click="onTabClick">

          <v-tab-pane tab-key="signIn" tab="Sign In">
            <v-button type="primary" class="google-signin-btn" @click="signInWithGoogle">SignIn with Google</v-button>
            <div class="or-text">- or -</div>
            <v-form direction="vertical" :model="signInForm" :rules="signInRules" ref="signInformRef">
              <v-form-item label="Registered Email" prop="email">
                <input type="text" class="input" v-model="signInForm.email" placeholder="Registered Email"
                  @keyup.enter="() => signInWithEmail('signInformRef')" />
              </v-form-item>
              <v-form-item label="Password" prop="password">
                <input type="password" class="input" v-model="signInForm.password" placeholder="Password"
                  @keyup.enter="() => signInWithEmail('signInformRef')" />
              </v-form-item>
              <v-form-item class="action-btns">
                <v-button type="primary" style="margin-right:10px" @click.prevent="signInWithEmail('signInformRef')">Sign In</v-button>
                <v-button type="default" style="margin-right:10px" @click.prevent="() => activeTab='signUp'">Sign Up</v-button>
              </v-form-item>
            </v-form>
          </v-tab-pane>

          <v-tab-pane tab-key="signUp" tab="Sign Up" @tab-click="onTabClick">
            <v-form direction="vertical" :model="signUpForm" :rules="signUpRules" ref="signUpformRef">
              <v-form-item label="Email" prop="email">
                <input type="text" class="input" v-model="signUpForm.email" placeholder="Email"
                  @keyup.enter="() => signUpWithEmail('signUpformRef')" />
              </v-form-item>
              <v-form-item label="Password" prop="password">
                <input type="password" class="input" v-model="signUpForm.password" placeholder="Password"
                  @keyup.enter="() => signUpWithEmail('signUpformRef')" />
              </v-form-item>
              <v-form-item label="Confirm Password" prop="confirm_password">
                <input type="password" class="input" v-model="signUpForm.confirm_password" placeholder="Confirm Password"
                  @keyup.enter="() => signUpWithEmail('signUpformRef')" />
              </v-form-item>
              <v-form-item label="Access the application as a" prop="type">
                <v-select placeholder="Access the application as a" size="large" v-model="signUpForm.type"
                  :data="[{label: 'Student', value: 'Student'}, {label: 'Associate', value: 'Associate'}]"></v-select>
              </v-form-item>
              <v-form-item class="action-btns">
                <v-button type="primary" style="margin-right:10px" @click.prevent="signUpWithEmail('signUpformRef')">Sign Up</v-button>
                <v-button type="default" style="margin-right:10px" @click.prevent="() => activeTab='signIn'">Sign In</v-button>
              </v-form-item>
            </v-form>
          </v-tab-pane>

          <v-tab-pane tab-key="forgotPassword" tab="Forgot Password" @tab-click="onTabClick">
            <v-form direction="vertical" :model="forgotPasswordForm" :rules="forgotPasswordRules" ref="forgotPasswordformRef">
              <v-form-item label="Email" prop="email">
                <input type="text" class="input" v-model="forgotPasswordForm.email" placeholder="Email"
                  @keyup.enter="() => sendForgotPasswordMail('forgotPasswordformRef')" />
              </v-form-item>
              <v-form-item class="action-btns">
                <v-button type="primary" style="margin-right:10px" @click.prevent="sendForgotPasswordMail('forgotPasswordformRef')">Send e-Mail</v-button>
              </v-form-item>
            </v-form>
          </v-tab-pane>

        </v-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import fb from '@/firebase'
import { mapGetters } from 'vuex'

export default {
  name: 'Auth',
  data () {
    const validateEmail = (rule, value, callback) => {
      const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
      if (emailPattern.test(value)) {
        callback()
      } else {
        callback(new Error('* Invalid Email'))
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('* Min characters(6)'))
      } else {
        callback()
      }
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.signUpForm.password) {
        callback(new Error('* Password mismatch'))
      } else {
        callback()
      }
    }

    return {
      activeTab: 'signIn',
      signInForm: {
        email: null,
        password: null
      },
      signInRules: {
        email: [{
          required: true,
          message: '* Required'
        }],
        password: [{
          required: true,
          message: '* Required'
        }]
      },
      signUpForm: {
        email: null,
        password: null,
        type: null
      },
      signUpRules: {
        email: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateEmail
        }],
        password: [{
          required: true,
          message: '* Required'
        }, {
          validator: validatePassword
        }],
        confirm_password: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateConfirmPassword
        }],
        type: [{
          required: true,
          message: '* Required'
        }]
      },
      forgotPasswordForm: {
        email: null
      },
      forgotPasswordRules: {
        email: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateEmail
        }]
      }
    }
  },
  computed: {
    ...mapGetters([
      'user',
    ])
  },
  watch: {
    user: {
      handler (val) {
      },
      immediate: true
    }
  },
  methods: {
    signInWithGoogle () {
      this.$store.dispatch('signInWithGoogle', this.signInForm)
      fb.signInWithGoogle()
    },
    signOut () {
      fb.logout()
      this.$router.push('/auth')
    },
    signInWithEmail (formRef) {
      this.$refs[formRef].validate((valid) => {
        if (valid) {
          this.$store.dispatch('signInWithEmail', this.signInForm)
        } else {
          return false
        }
      })
    },
    signUpWithEmail (formRef) {
      this.$refs[formRef].validate((valid) => {
        if (valid) {
          this.$store.dispatch('signUpWithEmail', {
            email: this.signUpForm.email,
            password: this.signUpForm.password,
            type: this.signUpForm.type})
        } else {
          return false
        }
      })
    },
    sendForgotPasswordMail (formRef) {
      this.$refs[formRef].validate((valid) => {
        if (valid) {
          this.$store.dispatch('sendForgotPasswordMail', {
            email: this.forgotPasswordForm.email})
        } else {
          return false
        }
      })
    },
    onTabClick(tabKey) {
      this.activeTab = tabKey
    }
  }
}
</script>

<style scoped>
.login-outer-wrap {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.login-outer-wrap .page-header {
  background-color: #ff3366 !important;
  width: 500px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ivory;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 16px;
} 
.login-wrap {
  width: 500px;
  height: auto;
  min-height: 518px;
  padding: 20px;
  box-shadow: 1px 1px 2px 7px rgba(255, 51, 102, .1);
}
.google-signin-btn {
  background-color: #db3236 !important;
  width: 100%;
}
.or-text {
  margin: 30px 0;
  font-size: 16px;
  display: flex;
  justify-content: center;
}
.action-btns {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.action-btns button {
  width: 120px;
}
.input {
  position: relative;
  display: inline-block;
  width: 100%;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(0,0,0,.65);
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-transition: all .3s;
  transition: all .3s;
  padding: 6px 7px;
  height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/views/Auth.vue